import React, { useEffect } from "react";
import Header from "../../components/home/Header";
import Footer from "../../components/home/Footer";
import AboutDetailsContainer from "../../components/about/AboutDetailsContainer";

const AboutDetailspage = () => {
  useEffect(() => {
    window.scroll("scroll", function () {
      window.scroll(0, 0);
    });
  }, []);
  return (
    <div>
      <Header />
      <AboutDetailsContainer />
      <Footer />
    </div>
  );
};

export default AboutDetailspage;
